import I18n from 'i18n-js';
import { IUser } from './components/user_context_provider';
import {
  reverb_search_ListingItemRegionRelation as ItemRegionRelation,
  reverb_search_SimilarListingsSearchRequest as SimilarListingsSearchRequest,
  reverb_search_ListingsSearchRequest as ListingsSearchRequest,
} from './rql';
import { isExperimentEnabled, isNonUSUser } from './user_context_helpers';
import experiments from './experiments';
import { EUROPEAN_UNION_COUNTRY_CODES } from './geo';

export function showItemPageListingFlags(user: Partial<IUser>) {
  if (isExperimentEnabled(user, experiments.COUNTRY_FLAGS_ITEM_PAGE)) {
    return isNonUSUser(user);
  } else {
    return !!user.countryCode && !['US', 'GB'].includes(user.countryCode);
  }
}

// this is for the localized row experiment
const LOCALIZED_ROW_EXPERIMENT_COUNTRIES = ['AU', 'BR', 'CA', 'NO', ...EUROPEAN_UNION_COUNTRY_CODES];

export function isCountryWithLocalizedRows(user: Partial<IUser>) {
  return LOCALIZED_ROW_EXPERIMENT_COUNTRIES.includes(user.countryCode);
}

export function showShopRow(user: Partial<IUser>) {
  const userInExp = isExperimentEnabled(user, experiments.LOCALIZED_ROWS_ON_ITEM_PAGES);

  return (user.countryCode === 'GB') || (userInExp && isCountryWithLocalizedRows(user));
}

export function showLocalizedListingContent(user: Partial<IUser>) {
  return isNonUSUser(user);
}

export function localizeSimilarListingsFilters(user: Partial<IUser>): SimilarListingsSearchRequest {
  if (showLocalizedListingContent(user)) {
    return {
      ...withItemRegionRelation(user),
      itemRegion: user.countryCode,
    };
  }

  return {};
}

export function localizedSimilarListingsTitle(user: Partial<IUser>) {
  const userInExp = isExperimentEnabled(user, experiments.LOCALIZED_ROWS_ON_ITEM_PAGES);

  if (user.countryCode === 'GB') {
    return I18n.t('commons.listingRow.similarListings.uk');
  } else if (userInExp &&
            LOCALIZED_ROW_EXPERIMENT_COUNTRIES.includes(user.countryCode) &&
            !EUROPEAN_UNION_COUNTRY_CODES.includes(user.countryCode)) {
    return I18n.t(`commons.listingRow.similarListings.${user.countryCode.toLowerCase()}`);
  } else if (userInExp && EUROPEAN_UNION_COUNTRY_CODES.includes(user.countryCode)) {
    return I18n.t('commons.listingRow.similarListings.eu');
  }

  return I18n.t('commons.listingRow.similarListings.default');
}

function withItemRegionRelation(user: Partial<IUser>) {
  const showItemRegionOnly = !user.countryCode || user.countryCode == 'GB';

  if (showItemRegionOnly) { return {}; }

  return {
    itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
  };
}

export function localizeListingsRowsFilters(user: Partial<IUser>): ListingsSearchRequest {
  if (showLocalizedListingContent(user)) {
    return {
      itemRegion: user.countryCode,
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  return {};
}
